import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["term", "deposit", "tenure", "sale_type"]
  static values = { terms: Object }

  update() {
    const selectedId = this.termTarget.value
    if (!selectedId) {
      this.depositTarget.textContent = "-"
      this.tenureTarget.textContent = "-"
      this.sale_typeTarget.textContent = "-"
      return
    }

    const term = this.termsValue[selectedId]
    this.depositTarget.textContent = term.deposit
    this.tenureTarget.textContent = term.tenure
    this.sale_typeTarget.textContent = term.sale_type
  }
}
